"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMedia;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _MediaConstants = require("./MediaConstants");

function UIMedia(props) {
  var align = props.align,
      className = props.className,
      spacing = props.spacing,
      rest = (0, _objectWithoutProperties2.default)(props, ["align", "className", "spacing"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('media', 'private-media', _MediaConstants.MEDIA_ALIGNMENT_TYPES[align], _MediaConstants.MEDIA_SPACING[spacing], className)
  }));
}

UIMedia.displayName = 'UIMedia';
UIMedia.propTypes = {
  align: _propTypes.default.oneOf(Object.keys(_MediaConstants.MEDIA_ALIGNMENT_TYPES)),
  children: _propTypes.default.node.isRequired,
  spacing: _propTypes.default.oneOf(Object.keys(_MediaConstants.MEDIA_SPACING)).isRequired
};
UIMedia.defaultProps = {
  spacing: 'small'
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/layout/UIMedia.js
// module id = 748
// module chunks = 209 210 211 212